import { render } from "./SemanaElaborada.vue?vue&type=template&id=6b6ac650&scoped=true"
import script from "./SemanaElaborada.vue?vue&type=script&lang=js"
export * from "./SemanaElaborada.vue?vue&type=script&lang=js"

import "./SemanaElaborada.vue?vue&type=style&index=0&id=6b6ac650&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6ac650"]])

export default __exports__